// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3fEZu","title":"AfterFrontImage_title__27Plm"};